export default __webpack_public_path__ + "static/media/deauville14.81ccdb7d.jpg";